import { emailPlaceholder, phoneHref, whatsappHref } from '../data';

const EXPLORE = [
  { label: 'Sarees', href: '#sarees' },
  { label: 'Men\u2019s Wear', href: '#menswear' },
  { label: 'Collections', href: '#collections' },
  { label: 'Market', href: '#market' },
  { label: 'Gallery', href: '#gallery' },
];

const ABOUT = [
  { label: 'Our Story', href: '#story' },
  { label: 'Heritage', href: '#story' },
  { label: 'Contact', href: '#contact' },
];

const LEGAL = [
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms', href: '#' },
  { label: 'Cookie Policy', href: '#' },
];

function LinkGroup({ title, links }: { title: string; links: { label: string; href: string }[] }) {
  return (
    <div>
      <h3 className="text-[11px] font-semibold uppercase tracking-[0.24em] text-accent-300">{title}</h3>
      <ul className="mt-4 space-y-2.5">
        {links.map((link) => (
          <li key={link.label}>
            <a href={link.href} className="text-[14px] text-background-100/80 transition-colors hover:text-background-50">
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="font-heading text-3xl font-semibold tracking-[0.06em] text-background-50">SRM TEXTILES</p>
            <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-accent-300">Limited</p>
            <p className="mt-5 max-w-sm text-[14px] leading-relaxed text-background-100/70">
              Traditional Indian textiles and clothing — sarees, dhotis, veshtis and ethnic
              wear, brought closer to communities across the UK.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={phoneHref}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-300 hover:text-accent-300"
                aria-label="Call SRM Textiles"
              >
                <i className="ri-phone-line" aria-hidden="true" />
              </a>
              <a
                href={whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-300 hover:text-accent-300"
                aria-label="WhatsApp SRM Textiles"
              >
                <i className="ri-whatsapp-line" aria-hidden="true" />
              </a>
              <a
                href={`mailto:${emailPlaceholder}`}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-300 hover:text-accent-300"
                aria-label="Email SRM Textiles"
              >
                <i className="ri-mail-line" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <LinkGroup title="Explore" links={EXPLORE} />
          </div>
          <div className="lg:col-span-2">
            <LinkGroup title="About" links={ABOUT} />
          </div>
          <div className="lg:col-span-3">
            <LinkGroup title="Contact" links={[{ label: 'Call us', href: phoneHref }, { label: 'WhatsApp us', href: whatsappHref }, { label: 'Email us', href: `mailto:${emailPlaceholder}` }]} />
            <div className="mt-6">
              <h3 className="text-[11px] font-semibold uppercase tracking-[0.24em] text-accent-300">Legal</h3>
              <ul className="mt-4 space-y-2.5">
                {LEGAL.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-[14px] text-background-100/80 transition-colors hover:text-background-50">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-background-50/10 pt-8">
          <p className="text-[12px] text-background-100/60">
            SRM TEXTILES LIMITED | Company No. 17367788
          </p>
          <p className="text-[12px] text-background-100/60">Traditional Indian Textiles • Serving Customers Across the UK</p>
        </div>
      </div>
    </footer>
  );
}